<template>
    <div id="produk-form">
        <ol class="breadcrumb pull-right">
            <li>
                <router-link :to="{ path: '/' }">Home</router-link>
            </li>
            <li>Pembayaran</li>
            <li>
                <router-link :to="{ path: '/produk' }">Transaksi</router-link>
            </li>
            <li class="active">Detail Transaksi</li>
        </ol>

        <h1 class="page-header">Detail Transaksi</h1>

        <div class="row">
            <div class="col-md-12">
                <div class="panel panel-inverse">
                    <div class="panel-heading">
                        <h4 class="panel-title">Detail Transaksi</h4>
                    </div>
                    <div class="panel-body">
                        <div
                            class="alert alert-danger fade in m-b-15"
                            v-if="this.errors.length > 0"
                        >
                            <span class="close" data-dismiss="alert"
                                >&times;</span
                            >
                            <strong>Terjadi kesalahan!</strong>
                            <ul>
                                <li
                                    v-for="(message, key) in this.errors"
                                    :key="key"
                                >
                                    {{ message }}
                                </li>
                            </ul>
                        </div>

                        <form>
                            <div class="form-horizontal form-bordered">
                                <div class="form-group">
                                    <label class="col-md-2 control-label"
                                        >ID Transaksi</label
                                    >
                                    <div class="col-md-8 col-xs-12">
                                        <input
                                            type="text"
                                            readonly
                                            class="form-control"
                                            v-model="data.order_id"
                                        />
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="col-md-2 control-label"
                                        >Email</label
                                    >
                                    <div class="col-md-8 col-xs-12">
                                        <input
                                            readonly
                                            class="form-control"
                                            type="text"
                                            v-model="data.email"
                                        />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-md-2 control-label"
                                        >Nama Siswa</label
                                    >
                                    <div class="col-md-8 col-xs-12">
                                        <input
                                            class="form-control"
                                            readonly
                                            type="text"
                                            v-model="data.nama_siswa"
                                        />
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="col-md-2 control-label"
                                        >Sekolah</label
                                    >
                                    <div class="col-md-8 col-xs-12">
                                        <input
                                            readonly
                                            class="form-control"
                                            type="text"
                                            v-model="data.nama_siswa"
                                        />
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="col-md-2 control-label"
                                        >Nama Paket</label
                                    >
                                    <div class="col-md-8 col-xs-12">
                                        <input
                                            readonly
                                            class="form-control"
                                            type="text"
                                            v-model="data.paket"
                                        />
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="col-md-2 control-label"
                                        >Nama Group</label
                                    >
                                    <div class="col-md-8 col-xs-12">
                                        <input
                                            type="text"
                                            readonly
                                            class="form-control"
                                            v-model="data.group"
                                        />
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="col-md-2 control-label"
                                        >Nominal (Rp.)</label
                                    >
                                    <div class="col-md-8 col-xs-12">
                                        <div class="input-group">
                                            <span class="input-group-addon"
                                                >Rp</span
                                            >
                                            <vue-numeric
                                                readonly
                                                class="form-control"
                                                separator=","
                                                v-model="data.nominal"
                                            />
                                            <span class="input-group-addon"
                                                >,00</span
                                            >
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="col-md-2 control-label"
                                        >Status</label
                                    >
                                    <div class="col-md-8 col-xs-12">
                                        <input
                                            readonly
                                            class="form-control"
                                            v-model="data.status"
                                        />
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="col-md-2 control-label"
                                        >Batas Waktu Pembayaran</label
                                    >
                                    <div class="col-md-8 col-xs-12">
                                        <input
                                            readonly
                                            class="form-control"
                                            v-model="data.status"
                                        />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-md-2 control-label"
                                        >Waktu Pembayaran</label
                                    >
                                    <div class="col-md-8 col-xs-12">
                                        <input
                                            readonly
                                            class="form-control"
                                            v-model="data.status"
                                        />
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="col-md-2 control-label"
                                        >Metode Pembayaran</label
                                    >
                                    <div class="col-md-8 col-xs-12">
                                        <input
                                            readonly
                                            class="form-control"
                                            v-model="data.status"
                                        />
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="col-md-2 control-label"
                                        >Nomor Rekening Pembayaran</label
                                    >
                                    <div class="col-md-8 col-xs-12">
                                        <input
                                            readonly
                                            class="form-control"
                                            v-model="data.status"
                                        />
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="col-md-2 control-label"
                                        >Bank</label
                                    >
                                    <div class="col-md-8 col-xs-12">
                                        <input
                                            class="form-control"
                                            readonly
                                            v-model="data.status"
                                        />
                                    </div>
                                </div>
                            </div>
                        </form>
                        <hr />
                    </div>
                </div>
            </div>
        </div>
        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Jadwalkelaschooser from "@/modules/pembayaran/components/JadwalKelasChooser";
import SalesService from "@/modules/global/services/sales.js";
import Spinner from "@/modules/global/components/plugins/Spinner";

export default {
    name: "produk-form",

    components: {
        "app-jadwalkelaschooser": Jadwalkelaschooser,
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            errors: [],
            isLoading: false,
            status: {
                PUBLISH: "PUBLISHED",
                UNPUBLISH: "UNPUBLISHED",
            },
            type: {
                SUBSCRIPTION: "SUBSCRIPTION",
                TICKET: "TICKET",
            },
            queryId: null,
            selectedPicture: null,
            data: {
                package_level: "",
                type: "SUBSCRIPTION",
                discount: null,
                package_name: null,
                package_type: "",
                app_scope: [""],
                package_description: null,
                package_groups: [],
                code: "",
                ammount: "",
                normal_price: 0,
                start_date: "",
                expiry_date: "",
                actual_price: 0,
                is_active: 1,
            },
            tryouts: [],
            editor: ClassicEditor,
            editorConfig: {
                toolbar: [
                    "heading",
                    "|",
                    "bold",
                    "italic",
                    "link",
                    "bulletedList",
                    "numberedList",
                    "blockQuote",
                    "|",
                    "outdent",
                    "indent",
                ],
            },
            scopes: [
                {
                    id: 8,
                    text: "app_scheduled_tryout",
                    display_text: "User: Access Scheduled Tryout",
                    description:
                        "Give user privilege to access scheduled tryout feature",
                    created_at: "2019-03-13 00:47:03",
                    updated_at: "2019-03-13 00:47:03",
                },
                {
                    id: 9,
                    text: "app_itembank",
                    display_text: "User: Access Itembank",
                    description:
                        "Give user privilege to access itembank feature",
                    created_at: "2019-03-13 00:47:03",
                    updated_at: "2019-03-13 00:47:03",
                },
                {
                    id: 55,
                    text: "app_consultation",
                    display_text: "app_consultation",
                    display_name: "User: Access Consultation",
                    description:
                        "Give privileges to access consultation features",
                    created_at: "2020-05-04 02:44:01",
                    updated_at: "2020-05-04 02:44:01",
                },
                {
                    id: 64,
                    text: "app_liveclass",
                    display_text: "app_liveclass",
                    display_name: "User: Access Live Class",
                    description:
                        "Give privileges to access live class features",
                    created_at: "2021-07-18 12:20:45",
                    updated_at: "2021-07-18 12:32:06",
                },
            ],
            topic: null,
            startDate: null,
            endDate: null,
        };
    },

    mounted: function () {
        var context = this;
        if (this.$route.query.id) {
            this.queryId = this.$route.query.id;
            this.fetchData();
        }
        if (!this.$route.query.id) {
            DatepickerPlugin.init("#startDate", function (value) {
                context.data.start_date = value;
            });

            DatepickerPlugin.init("#endDate", function (value) {
                context.data.expiry_date = value;
            });
        }
    },

    methods: {
        fetchData() {
            var context = this;
            var queryId = this.queryId;
            this.isLoading = true;

            SalesService.getDetailTransaksi(queryId, function (result) {
                context.isLoading = false;

                if (result.success) {
                    context.data = result.data;
                } else {
                    alert("Terjadi Kesalahan : " + result.message);
                }
            });
        },

        addTryoutIntoGroup: function (tryout) {
            const datas = {
                id: tryout.data[0],
                desc: tryout.data[1],
                quota: tryout.data[2],
                threshold: tryout.data[3],
                start_time: tryout.data[4],
                end_time: tryout.data[5],
            };
            this.data.package_groups.push(tryout.id);
            this.tryouts.push(datas);
        },

        removeTryoutFromGroup: function (index) {
            var confirmed = window.confirm(
                "Apakah anda yakin akan melepas Jadwal ini?",
            );

            if (confirmed) {
                this.data.package_groups.splice(index, 1);
                this.tryouts.splice(index, 1);
            }
        },

        saveData: function () {
            var context = this;
            var data = this.data;

            if (this.validateForm()) {
                context.isLoading = true;
                data.package_grade = [data.package_grade];
                SalesService.createTransaksi(data, function (result) {
                    if (result.success) {
                        alert("berhasil simpan ");
                        context.$router.go(-1);
                    } else {
                        alert("Terjadi Kesalahan");
                        context.isLoading = false;
                    }
                    context.isLoading = false;
                });
            } else {
                this.isLoading = false;
                $(window).scrollTop(0);
            }
        },

        editData: function () {
            var context = this;
            var id = this.queryId;
            var data = this.data;
            this.isLoading = true;
            data.package_grade = [this.data.package_grade];

            if (this.validateForm()) {
                SalesService.updateTransaksi(id, data, function (result) {
                    if (result.success) {
                        alert("berhasil simpan ");
                        context.$router.go(-1);
                    } else {
                        alert("Terjadi Kesalahan");
                        context.isLoading = false;
                    }
                    context.isLoading = false;
                });
            } else {
                this.isLoading = false;
                $(window).scrollTop(0);
            }
        },

        handleChangePicture: function (event) {
            const file = event.target.files[0];
            this.selectedPicture = file;
            this.data.picture = URL.createObjectURL(file);
        },

        doUploadPicture: function (id) {
            var context = this;
            var picture = this.selectedPicture;
            var formData = new FormData();

            if (picture) {
                formData.append("name", picture.name);
                formData.append("file", picture);

                SalesService.uploadTransaksiPicture(
                    id,
                    formData,
                    function (result) {
                        if (result.success)
                            context.$router.push({ path: "/produk" });
                        else {
                            alert("Gagal Upload Picture : " + result.message);
                            context.isLoading = false;
                        }
                    },
                );
            } else {
                context.$router.push({ path: "/produk" });
            }
        },

        validateForm() {
            this.errors = [];
            if (!this.data.type) {
                this.errors.push("Tipe produk wajib diisi");
            } else {
                if (!this.data.package_name)
                    this.errors.push("Nama Transaksi wajib diisi");
                if (!this.data.package_level)
                    this.errors.push("Jenjang wajib diisi");
                if (!this.data.package_description)
                    this.errors.push("Deskripsi wajib diisi");
                if (this.data.package_grade.length < 1)
                    this.errors.push("Kelas wajib diisi");
                if (!this.data.feature_description)
                    this.errors.push("Fitur wajib diisi");
                if (!this.data.actual_price)
                    this.errors.push("Harga Asli wajib diisi");
                if (this.data.normal_price) {
                    if (this.data.actual_price >= this.data.normal_price)
                        this.errors.push(
                            "Harga Normal tidak boleh lebih dari atau sama dengan harga asli",
                        );
                }
                if (this.data.app_scope.length > 0) {
                    this.data.app_scope.forEach((e) => {
                        if (e == "") {
                            this.errors.push("User scope wajib diisi");
                        }
                    });
                }
                if (this.data.package_groups.length < 1)
                    this.errors.push("Jadwal Kelas wajib diisi");

                if (
                    this.data.package_type === "ANNUALLY" &&
                    !this.data.start_date
                )
                    this.errors.push("Tanggal mulai wajib di isi");
                if (
                    this.data.package_type === "ANNUALLY" &&
                    !this.data.expiry_date
                )
                    this.errors.push("Tanggal selesai wajib di isi");
            }
            return this.errors.length == 0;
        },

        characterCounter: function (text) {
            text = text.replace(/<[^>]*>/g, "");
            text = text.replace(/\&nbsp;/g, " ");
            return text.length;
        },
    },
};
</script>

<style>
.ck-content {
    min-height: 120px;
}
</style>



// WEBPACK FOOTER //
// Form.vue?88749e02